export enum WaterAdditionHistoryMessages {
  title = "waterAdditionHistory.title",
  waterAdditionHistory = "waterAdditionHistory.waterAdditionHistory",
  filterTitle = "waterAdditionHistory.filterTitle",
  fleetCode = "waterAdditionHistory.fleetCode",
  licensePlate = "waterAdditionHistory.licensePlate",
  startDate = "waterAdditionHistory.startDate",
  finishDate = "waterAdditionHistory.finishDate",
  driver = "waterAdditionHistory.driver",
  document = "waterAdditionHistory.document",
  vehicleState = "waterAdditionHistory.vehicleState",
  waterAdded = "waterAdditionHistory.waterAdded",
  moment = "waterAdditionHistory.moment",
  address = "waterAdditionHistory.address",
  preDischarge = "waterAdditionHistory.preDischarge",
  postDischarge = "waterAdditionHistory.postDischarge",
  noDataFound = "waterAdditionHistory.noDataFound"
}

export interface TranslationWaterAdditionHistoryMessages {
  [WaterAdditionHistoryMessages.title]: string;
  [WaterAdditionHistoryMessages.waterAdditionHistory]: string;
  [WaterAdditionHistoryMessages.filterTitle]: string;
  [WaterAdditionHistoryMessages.fleetCode]: string;
  [WaterAdditionHistoryMessages.licensePlate]: string;
  [WaterAdditionHistoryMessages.startDate]: string;
  [WaterAdditionHistoryMessages.finishDate]: string;
  [WaterAdditionHistoryMessages.driver]: string;
  [WaterAdditionHistoryMessages.document]: string;
  [WaterAdditionHistoryMessages.vehicleState]: string;
  [WaterAdditionHistoryMessages.waterAdded]: string;
  [WaterAdditionHistoryMessages.moment]: string;
  [WaterAdditionHistoryMessages.address]: string;
  [WaterAdditionHistoryMessages.preDischarge]: string;
  [WaterAdditionHistoryMessages.postDischarge]: string;
  [WaterAdditionHistoryMessages.noDataFound]: string;
}
